export const HOME_ROUTE = {
  TITLE: 'Home',
  ABSOLUTE_PATH: '/home',
  EXACT_PATH: '/home',
  PARENT_PATH: '/home/*',
};
